import type { FormSchema } from '@cli-types/core-engine/schema.js'
import { getStepFieldNames } from '@core-engine/schema/field-helpers/form-fields/get-step-field-names.js'

export function buildStepsConstant(steps: NonNullable<FormSchema['steps']>): string {
  const entries = steps.map((step) => {
    const fieldNames = getStepFieldNames(step)
    const fieldsStr = fieldNames.map((n) => JSON.stringify(n)).join(', ')
    const desc = step.description ? `, description: ${JSON.stringify(step.description)}` : ''
    return `  { name: ${JSON.stringify(step.name)}, label: ${JSON.stringify(step.label)}${desc}, fields: [${fieldsStr}] }`
  })
  return `const STEPS = [\n${entries.join(',\n')}\n]`
}
